module.exports = __webpack_public_path__ + "static/21-dd9107dc325bb2ce8d26b0f9440c3a1d.png";